module.exports = __webpack_public_path__ + "img/widget.a53dcde7.png";